import styled from 'styled-components';

export const StyledImg = styled('img')({
  width: '50px',
  height: '50px',
  objectFit: 'cover',
  borderRadius: '4px',
});
